export const formatNumberWithComma = (num: number) => {
  return new Intl.NumberFormat('en-US').format(num);
};
